import { UserEntity } from "../entity/UserEntity";
import { InternalUser } from "../gateway/InternalUser/InternalUser";

export class GetInternalUsersUsecase {
    constructor() {
        this.InternalUserGateway = new InternalUser();
    }

    async execute({ filters } = {}) {
        const payload = this.sanitizeInput({ filters });
        const users = await this.InternalUserGateway.getAll();
        if (!payload.filters.roles.length) {
            return users;
        }
        const filteredUsers = this.filterUsersByRoles(
            users,
            payload.filters.roles
        );
        return this.restoreEntities(filteredUsers);
    }

    sanitizeInput({ filters } = {}) {
        const rawRoles = filters?.roles;
        const roles = Array.isArray(rawRoles)
            ? rawRoles
                  .map((role) => String(role).trim())
                  .filter((role) => Boolean(role))
            : [];
        return {
            filters: {
                roles
            }
        };
    }

    filterUsersByRoles(users, roles) {
        return users.filter(
            (user) =>
                user &&
                typeof user.role === "string" &&
                roles.includes(user.role)
        );
    }

    restoreEntities(users) {
        return users.map((user) => UserEntity.restoreFromCloud(user));
    }
}
